import { encryptAES } from '../encryption/CryptoService';

const IS_ENCRYPTION_ENABLED = process.env.REACT_APP_IS_ENCRYPTION === 'true';

// Sub-helper 1: Handles POST payload transformations cleanly
const handlePostBody = (body) => {
    if (body === undefined || body === null) return undefined;

    const plainText = typeof body === 'string' ? body : JSON.stringify(body);

    return IS_ENCRYPTION_ENABLED
        ? { data: encryptAES(plainText) }
        : { data: plainText };
};

// Sub-helper 2: Handles GET/DELETE parameter stringification/encryption
const handleQueryParams = (params) => {
    if (params === undefined || params === null) return undefined;

    // getData often passes a bare id (number/string). Wrap so fetchBaseQuery
    // always receives an object and backend GetQueryInt can read `data`.
    const normalized =
        typeof params === "object" && !Array.isArray(params)
            ? params
            : { data: params };

    const alreadyWrapped =
        Object.keys(normalized).length === 1 && "data" in normalized;
    const valueToProcess = alreadyWrapped
        ? String(normalized.data)
        : JSON.stringify(normalized);

    return IS_ENCRYPTION_ENABLED
        ? { data: encryptAES(valueToProcess) }
        : { data: valueToProcess };
};

// Main Orchestrator: Complexity drops from 19 to below 5!
export const encryptRequest = (args) => {
    const method = (args.method || 'GET').toUpperCase();

    if (args.body instanceof FormData) return args;

    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        const transformedBody = handlePostBody(args.body);
        return transformedBody !== undefined ? { ...args, body: transformedBody } : args;
    }

    if (method === 'GET' || method === 'DELETE') {
        const transformedParams = handleQueryParams(args.params);
        return transformedParams !== undefined ? { ...args, params: transformedParams } : args;
    }

    return args;
};
